import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type WorkflowStepRetryFailedAction = {
	type: 'WORKFLOW_STEP_RETRY_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): WorkflowStepRetryFailedAction => ({
	type: 'WORKFLOW_STEP_RETRY_FAILED',
	payload,
});
